import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MenuController } from '@ionic/angular';
import {AngularFireAuth} from '@angular/fire/auth';
import {take} from 'rxjs/operators';
import {AuthService} from '../auth/auth.service';
import {AccountServiceService} from '../../../../services/account/account-service.service';
import {AngularFireStorage} from '@angular/fire/storage';
import {AngularFirestore} from '@angular/fire/firestore';
import {Image} from '../../../../models/image/image';
import { CrudService } from '../../admin/services/crud/crud.service';
import { AccountModel } from 'src/models/accounts/account';
import { AppSettings, AppSettingsService } from 'src/services/app-settings.service';
@Component({
  selector: 'app-sign-comp-in-toolbar',
  templateUrl: './sign-comp-in-toolbar.component.html',
  styleUrls: ['./sign-comp-in-toolbar.component.scss'],
})
export class SignCompInToolbarComponent implements OnInit {

    authStatus = false;
    notInApp: boolean;
    authType: string;
    authStatusSubscribe: any;
    singleImage = {} as Image;
    appSettings: AppSettings;
  constructor(private menu: MenuController,
              private route: Router,
              private afAuth: AngularFireAuth,
              private authService: AuthService,
              private accountService: AccountServiceService,
              private storage: AngularFireStorage,
              private database: AngularFirestore,
              private crudService: CrudService<object, AccountModel>,
              private appSettingService: AppSettingsService
              ) {
                this.appSettingService.getSettings().then(res => {
                  this.appSettings = res;
                });

  }

  getUserRes() {
    this.authStatusSubscribe = this.afAuth.user.subscribe((data => {
      if (data) {
        this.accountService.getSingleImage(data.uid).subscribe(res => {
          this.singleImage = res;
          this.authStatus = true;
          console.log(res);
      });
      }

}));
  }

  ngOnInit() {
    this.getUserRes();



  }

   openAlert() {
  }

    openEnd() {
        this.menu.open('end').then();
    }
    signin() {
        this.menu.close('end').then();
        this.route.navigate(['./signin']).then();
    }
    closeMenu() {
        this.menu.close('end');
    }

    logout() {
      this.menu.close('end');
      return this.afAuth.signOut().then(() => {
          this.authService.logout();
          this.authStatus = false;
          this.route.navigate(['tabs/home']).then();
        });
    }

    goToProfile() {
     // this.route.navigate(['profile']).then();

     this.afAuth.onAuthStateChanged(user => {
      if (user) {
        user.getIdTokenResult().then(idTokenResult => {
          if (idTokenResult.claims.expert) {
            this.closeMenu();
            this.route.navigate(['expert-profile']).then();

          } else if (idTokenResult.claims.subscriber) {
            this.closeMenu();
            this.route.navigate(['profile']).then();
          }
        });
      } else {

      }
    }).then(() => {
    }).catch(() => {
      console.log('not found');
    });
    }

    goToPanel() {


            this.afAuth.onAuthStateChanged(user => {
        if (user) {
          user.getIdTokenResult().then(idTokenResult => {
            if (idTokenResult.claims.expert) {
              this.closeMenu();
              this.route.navigate(['expert']).then();

            } else if (idTokenResult.claims.admin) {
              this.closeMenu();
              this.route.navigate(['admin']).then();

            } else if (idTokenResult.claims.subscriber) {
              this.closeMenu();
              this.route.navigate(['settings']).then();
            }
          });
        } else {

        }
      }).then(() => {
      }).catch(() => {
        console.log('not found');
      });

    }

    goToApp() {

      this.afAuth.onAuthStateChanged(user => {
        if (user) {
          user.getIdTokenResult().then(idTokenResult => {
            if (idTokenResult.claims.expert) {
              this.closeMenu();
              this.route.navigate(['/tabs/home']).then();

            } else if (idTokenResult.claims.admin) {
              this.closeMenu();
              this.route.navigate(['/tabs/home']).then();

            } else if (idTokenResult.claims.subscriber) {
              this.closeMenu();
              this.route.navigate(['/tabs/home']).then();
            }
          });
        } else {

        }
      }).then(() => {
      }).catch(() => {
        console.log('not found');
      });
    }

    ionViewWillEnter() {
      this.getUserRes();
    }
    ionViewWillLeave() {
/*       if (this.authStatusSubscribe) {
        this.authStatusSubscribe.unsubscribe();
      } */
    }
    contactModal() {
      this.menu.close('end').then();
      this.route.navigate(['contact-modal']).then();
    }

    aboutModal() {
      this.menu.close('end').then();
      this.route.navigate(['about-modal']).then();
    }
    privacyModal() {
      this.menu.close('end').then();
      this.route.navigate(['privacy-modal']).then();
    }
    contractModal() {
      this.menu.close('end').then();
      this.route.navigate(['contract-modal']).then();
    }

}
